// extracted by mini-css-extract-plugin
module.exports = {"input":"ConfigurableFormVariableConfiguration_input__dlwP3","hiddenInput":"ConfigurableFormVariableConfiguration_hiddenInput__1XOJB"};